import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { RecordService } from '../../../services/record.service';
import { ToastComponent } from '../../toast/toast.component';
import { Record } from '../../models/record.model';
import { RecordComment } from '../../types';
import { ee } from '../../constants';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-edit-comment-modal',
  templateUrl: './edit-comment-modal.component.html',
  standalone: false
})
export class EditCommentModalComponent implements OnInit, OnDestroy {
  toast = inject(ToastComponent);
  private recordService = inject(RecordService);


  @Input() record: Record;
  @Input() comment: RecordComment = { id: 0, text: '' };

  ngOnInit(): void {
    // This is executed N+1 times, to fix eventually
    ee.on('showEditCommentModal', (comment: RecordComment) => this.comment = comment);
  }

  ngOnDestroy(): void {
    ee.off('showEditCommentModal', () => {});
  }

  updateComment(record: Record): void {
    const comment = this.comment;
    comment.text = this.comment.text;
    this.recordService.updateComment(record, comment)
      .pipe(finalize(() => ee.emit('getRecord')))
      .subscribe({
        next: res => this.toast.setMessage('Comment updated successfully.', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
